import { render, staticRenderFns } from "./incentiveDetail.vue?vue&type=template&id=38e07f5e"
import script from "./incentiveDetail.vue?vue&type=script&lang=js"
export * from "./incentiveDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports